<template>
	<div :class="noData ? 'page_nodata' : ''">
		<div >
			<div v-if="noData">
				<div class="nodata bacwhite" v-if="!isNewMode" :style="{height:height+'px'}">
					<img class="no-img" :src="imgPath + 'queixngxy.png'" />
					<div class="no-tip">购物车竟然是空的</div>
				</div>
				

				<div class="new_mode" v-else  >
					<div class="new_home_null_data" v-if="isLogin">
						<img class="no-img" :src="imgPath + 'queixngxy.png'" />
						<p>当前有<b class="red">{{b_money}}</b>积分 赶快去兑换吧</p>
						<span class="go_duihuan" @click="$router.push('/')">立即去兑换</span>
					</div>
					<div class="new_home_null_data" v-else>
						<img class="no-img" :src="imgPath + 'queixngxy.png'" />
						<p>当前有<b class="red">****</b>积分,登录后兑换</p>
						<span class="go_duihuan" @click="goLogin()">请登录</span>
					</div>
					<div class="new_null_tuijian" v-if="list.length > 0">
						<p class="title_h2"><span></span>为您推荐<span></span></p>
						<div class="recommend_l">
							<div >
								<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
									offset='100'>
									<div class="tuijian_list_box">
										<div  v-for="(item,idx) in list " :key="idx"  @click="goPathUrl('/shopDetail?id=' + item.stock_id)">
											<homeCardItem  :itemObj='item'  :is_show_price='is_show_retail_price' ></homeCardItem>
										</div>
										
									</div>
								</van-list>
							</div>

						</div>
					</div>
				</div>
			</div>
			<!-- 20240312 -->

			<div class="container" v-else>
				<div class="head">
					<div class="left">库存紧张，伙伴们快快下单哦</div>
					<div class="right" @click="editFg">{{isEdit?'编辑':'完成'}}</div>
				</div>
				<div>
					<cart-item :isEdit="isEdit" :cart="true" @set="setMode" :index="index"
						@selectSingleGood="selectSingleGood" :info.sync="item" v-for="(item,index) in cartList"
						:key="'good'+index+item.add_time"></cart-item>
				</div>

				<div class="static flex_b w100">
					<div class="bleft flex">
						<iconfont :name="checkAll?'iconselected':'iconweixuanzhong'" size="0.68rem"
							:color="checkAll?'#FD3E3E':'#999'" @click="selectAll"></iconfont>
						<span class="handle">全选</span>
						<div class="bjf">
							<div>
								<span style="font-size: 0.56rem" class="hj">合计：</span>
								<span class="jf">￥{{count}}</span>
								<span class="jftip"></span>
							</div>
							<div class="express">快递运费：{{express}}元</div>
						</div>
					</div>
					<div class="bright" @click="handle">{{isEdit?'立即购买':'删除'}}</div>
				</div>
			</div>
		</div>


		<div class="zw"></div>
		<footer-view></footer-view>
		<mloading v-if="showLoading"></mloading>
	</div>
</template>

<script>
	import cartItem from '@/components/cartItem.vue'
	import homeCardItem from "@/components/homeCard.vue"
	import footerView from '@/components/footerView.vue'
	import Iconfont from '@/components/iconfont.vue'
	import mloading from '@/components/loading.vue'
	import {
		sendRequest
	} from '@/assets/public'
	var calculator = require('@/utils/calculator.js')
	import urlconfig from '@/config.js'
	import {
		Toast,
		Dialog
	} from 'vant'

	export default {
		components: {
			homeCardItem,
			cartItem,
			footerView,
			Iconfont,
			mloading
		},
		name: 'Cartpage',
		data() {
			return {
				noData: false,
				cartList: [],
				isEdit: true,
				checkAll: false,
				count: 0,
				reload: true,
				express: 0,
				ids: '',
				showLoading: false,
				height: document.body.clientHeight,
				list: [],
				loading: false,
				finished: false,
				isFixed: false,
				page: 1,
				isNewMode: 0,
				b_money:0,
				isLogin: localStorage.getItem('token'), //是否登录
				is_show_retail_price:0
			}
		},
		created(){
			// 2024.0312 新模版
			// console.log( localStorage.getItem('isNewMode'),'有缓存吗')
			if (localStorage.getItem('isNewMode')) {
				this.isNewMode = 1
				this.initFg()
			}
		},
		async mounted() {
			this.getList()
			// this.getRecomList()
		},
		methods: {
			goLogin() {
			  if (this.isWexinLogin) {
			    var appid = 'wxcef271c70c3c8428' // appid
			    var url = window.encodeURIComponent(`${urlconfig.goPath}personalCenter`) // 回调链接地址，需转码为URI格式，必须去除#后的参数
			    var scope = 'snsapi_base' // snsapi_base静默授权，snsapi_userinfo弹出授权页面
			    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${url}&response_type=code&scope=${scope}&state=state#wechat_redirect`
			  } else {
			    this.$router.push('/login')
			  }
			},
			async initFg() {
			  let res = await sendRequest("user/info", {
			    type: 1,
			  });
			  console.log(res);
			  if (res.status == 200) {
			    this.b_money = parseInt(res.content.member.b_money);
			    // console.log( parseInt(res.content.member.b_money) ,666666666666666)
			  }
			  // this.storeInfoFg();
			},
			goPathUrl(e){
				this.$router.push({
					  path: e,
					});
			},
			async getList() {
				this.showLoading = true
				let {
					content
				} = await sendRequest('cart/list', {})
				let tlist = content ? content.list : []
				this.cartList = tlist
				this.noData = tlist.length == 0
				this.showLoading = false
				if( tlist.length == 0 && this.isNewMode ){
					this.page=1
					this.getRecomList()
					return
				}
				this.calculate()
				
			},
			onLoad() {
				this.page++
				this.getRecomList()
			},
			getRecomList() {
				let _this = this;
				sendRequest("goods/list", {
						tag_type: 1,
						page: this.page,
						goods_type: '0',
						limit: 10
					})
					.then((result) => {
						_this.loading = false
					   _this.is_show_retail_price = result.content.is_show_retail_price
						let resList = result.content.list
						_this.list = [..._this.list, ...resList]
						if (resList.length == 0 || resList.length < 10 ) {
							_this.finished = true;
						}

					})
					.catch((err) => {});
			},
			setMode() {
				this.cartList = []
				this.getList()
			},
			editFg() {
				this.isEdit = !this.isEdit
				if (!this.isEdit) {
					let flag = 0
					for (let item of this.cartList) {
						if (item.selected) {
							flag++
						}
					}
					this.checkAll = flag == this.cartList.length
				}
			},
			//选择商品
			selectSingleGood(obj) {
				let nobj = this.cartList
				this.cartList = []
				nobj[obj.index] = obj.info
				this.cartList = nobj
				let flag = 0
				for (let item of nobj) {
					if (item.selected) {
						flag++
					}
				}
				let effectiveList = this.cartList.filter((item) => item.error_code <= 0)
				if (this.isEdit) {
					this.checkAll = flag == effectiveList.length
				} else {
					this.checkAll = flag == this.cartList.length
				}
				this.calculate()
			},
			showPopup() {
				this.show = true
			},
			selectAll() {
				this.checkAll = !this.checkAll
				this.reload = false
				let nobj = this.cartList
				this.cartList = []
				for (let item of nobj) {
					if (item.error_code <= 0 || !this.isEdit) {
						item.selected = this.checkAll
					}
				}
				setTimeout(() => {
					this.cartList = nobj
					this.reload = true
					this.calculate()
				}, 100)
			},
			async handle() {
				if (this.ids == '') {
					Toast('请选择商品')
					return
				}
				if (this.isEdit) {
					//兑换
					this.showLoading = true
					let {
						status,
						msg
					} = await sendRequest('cart/confirmList', {
						order_ids: this.ids,
						cart_type: 0,
					})
					this.showLoading = false
					if (status != 200) {
						Toast(msg)
						return
					}
					this.$router.push({
						name: 'orderConfirm',
						query: {
							ids: this.ids,
						},
					})
				} else {
					//删除
					Dialog.confirm({
							title: '提示',
							message: '确定要删除吗？',
							confirmButtonColor: '#FD3E3E',
						})
						.then(() => {
							this.deleteGoods()
						})
						.catch(() => {})
				}
			},
			async deleteGoods() {
				this.showLoading = true
				let res = await sendRequest('cart/delete', {
					order_ids: this.ids
				})
				this.showLoading = false
				Toast(res.msg)

				this.getList()
			},
			// 计算
			calculate() {
				let count = 0
				let express = 0
				let tarr = []
				for (let item of this.cartList) {
					if (item.selected) {
						count = calculator.add(
							count,
							parseInt(item.jinbi) * parseInt(item.buy_num)
						)
						express =
							item.is_calc_freight == 1 ?
							calculator.add(express, item.freight_format) :
							express
						tarr.push(item.id)
					}
				}

				console.log(count / 100, '9899')
				// this.count = (count/100).toFixed(2)
				this.count = count
				console.log(this.count, 'fdfdf')
				this.express = express
				this.ids = tarr.join(',')
			},
		},
	}
</script>

<style scoped>
	.head {
		width: calc(100% - 1.6rem);
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: #fff;
		font-size: 0.48rem;
		color: #fd3e3e;
		padding: 0.12rem 0.8rem;
	}

	.left {
		width: 10.6rem;
		line-height: 1.28rem;
		background: url('http://statics.7dingdong.com/static/wx_program_img/integral_mall/bejingh.png') no-repeat center;
		background-size: 100% 100%;
		padding-left: 0.4rem;
	}

	.right {
		width: 1.8rem;
		background: #ffe4e4;
		text-align: center;
		line-height: 1.2rem;
		border-radius: 0.2rem;
	}

	.nodata {
		width: 100%;
		height: 100%;
		text-align: center;
		padding: 2.94rem 0;
	}

	.page_nodata {
		height: 100vh;
		overflow: hidden;
	}

	.no-img {
		width: 10.5rem;
		height: 7.94rem;
	}

	.no-tip {
		width: 100%;
		font-size: 0.56rem;
		color: #999;
		margin-top: 0.28rem;
		text-align: center;
	}

	.static {
		position: fixed;
		bottom: 2rem;
		left: 0;
	}

	.bleft {
		width: 10.56rem;
		height: 2rem;
		padding-left: 0.8rem;
		background: #fff;
		align-items: center;
	}

	.bright {
		width: 3.64rem;
		height: 2rem;
		background: #fd3e3e;
		text-align: center;
		line-height: 2rem;
		font-size: 0.6rem;
		color: #fff;
	}

	.bjf {
		text-align: left;
		padding-bottom: 0.3rem;
	}

	.bjf .hj {
		font-size: 0.56rem;
	}

	.bjf .jf {
		font-size: 0.6rem;
		color: #fd3e3e;
	}

	.bjf .jftip {
		font-size: 0.44rem;
		color: #fd3e3e;
	}

	.bjf .express {
		font-size: 0.44rem;
		color: #999;
	}

	.handle {
		font-size: 0.56rem;
		margin-left: 0.2rem;
		margin-right: 1.1rem;
	}

	.popup-content {
		width: calc(100% - 1.4rem);
		padding: 0.6rem 0.7rem 0.8rem 0.7rem;
	}

	.phead {
		font-size: 0.6rem;
	}

	.popup-content .center {
		margin-top: 1.8rem;
		margin-bottom: 2rem;
	}

	.express-optioned {
		width: 2.66rem;
		height: 0.96rem;
		text-align: center;
		line-height: 0.96rem;
		font-size: 0.48rem;
		color: #fff;
		border-radius: 0.2rem;
		background: #fd3e3e;
	}

	.express-option {
		width: 2.66rem;
		height: 0.96rem;
		text-align: center;
		line-height: 0.96rem;
		font-size: 0.48rem;
		color: #999;
		border: 1px solid #ddd;
		border-radius: 0.2rem;
	}

	.cbutton {
		width: 13.6rem;
		border-radius: 0.2rem;
		text-align: center;
		line-height: 2rem;
		color: #fff;
		font-size: 0.6rem;
		background: #fd3e3e;
	}

	.zw {
		width: 100%;
		height: 4.5rem;
	}

	.new_mode {
		overflow-y: scroll;
		max-height: 100vh;

	}

	.new_home_null_data {
		text-align: center;
		color: #969799;
		font-size: 0.56rem;
	}

	.new_home_null_data .red {
		color: #FF463A;
	}

	.new_home_null_data p {
		margin: 0.4rem 0 0.8rem;
	}

	.new_home_null_data .go_duihuan {
		width: 10rem;
		height: 1.76rem;
		line-height: 1.76rem;
		text-align: center;
		border-radius: 0.88rem;
		color: #fff;
		font-size: 0.64rem;
		display: block;
		margin: 0 auto;
		background: #FF463A;
	}

	.new_null_tuijian {
		color: #000000;
		font-size: 0.72rem;
		margin-bottom: 2.2rem;
	}

	.new_null_tuijian .title_h2 {
		margin: 1.2rem 0 0 2.04rem;
		display: inline-block;
		/* font-weight: bold; */
		font-size: 0.72rem;
	}

	.new_null_tuijian span {
		width: 3.6rem;
		height: 1px;
		background: #E5E5E5;
		display: inline-block;
		margin-right: 0.4rem;
		vertical-align: middle;
	}

	.new_null_tuijian span:last-child {
		margin-left: 0.4rem;
	}

	.recommend_l {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		margin: 0.8rem 0.4rem;
	}
	.tuijian_list_box{
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		/* padding: 0 0.4rem; */
	}
</style>